import uuid from 'uuid/v4';
import { getKeyData } from '../selectors';
import { INIT_REMOTE_DATA, FETCHING_REMOTE_DATA, SET_REMOTE_DATA, ERROR_IN_REMOTE_DATA } from '../types';

// eslint-disable-next-line
export const useRemoteDataThunk = (key, onFetchRemoteData, initialState) => async (dispatch, getState) => {
  if (!key) {
    throw Error('key is mandatory');
  }

  if (!onFetchRemoteData) {
    throw Error('onFetchRemoteData is mandatory');
  }

  const remoteDate = getKeyData(getState(), { key, initialState });

  if (remoteDate && remoteDate.initialized && !remoteDate.invalidate) {
    return remoteDate;
  }

  if (remoteDate.offline) {
    return remoteDate;
  }

  if (remoteDate && !remoteDate.initialized) {
    dispatch({ type: INIT_REMOTE_DATA, payload: { key, initialState } });
  }

  const requestId = uuid();

  const safeFetch = async () => {
    const remoteDateSecondCheck = getKeyData(getState(), { key, initialState });

    if (remoteDateSecondCheck.requestId === requestId) {
      const data = await onFetchRemoteData();

      dispatch({ type: SET_REMOTE_DATA, payload: { key, data, initialState } });

      return data;
    }
    return remoteDateSecondCheck.data;
  };

  try {
    dispatch({ type: FETCHING_REMOTE_DATA, payload: { key, initialState, requestId } });

    const data = await safeFetch();

    return {
      initialized: true,
      loading: false,
      data,
    };
  } catch (ex) {
    dispatch({ type: ERROR_IN_REMOTE_DATA, payload: { key, initialState, ex } });
  }
};
